export default {
  name: 'BaseForm',
  model: {
    prop: 'values',
    event: 'update',
  },
  props: {
    values: {
      type: Object,
      // TODO: make this required once every form is moved to the new structure
      required: false,
    },
    errors: {
      type: Object,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    showGenericFeedback() {
      if (!this.$v) {
        return false;
      }

      return this.$v.$dirty && this.$v.$invalid;
    },
  },
  validations() {
    return {};
  },
  methods: {
    updateValue(key, value) {
      this.$emit('update', { [key]: value });
    },
    submit(formValues) {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      this.$emit('submit', formValues);
    },
    back() {
      this.$emit('back');
    },
  },
};
